import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './POIs.css';
import React, { useEffect, useState, useRef, useContext } from 'react';
import clsx from 'clsx';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { injectImageResolution, pathJoin, getMediaHost, getListingItemURL, generatrURLFromTags, getFeaturedItemAndList, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getTags, getDictionaryItem } from '../../utils';
import { formatTagsRuleToFilters, generateSeeMoreTagsFromRules, formatTagsRuleToFiltersOneByOne, isTagsRule } from '../../utils/getListing';
import CuratorPicks from '../atoms/CuratorPicks/CuratorPicks';
//resource
import { useInView } from 'react-intersection-observer';
import getListing, { loadCategoryAlgoliaResults } from '../../utils/getListing';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import LazyPicture from '../atoms/LazyPicture';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink/RouterLink';
import TripAdvisor from '../atoms/TripAdvisor/TripAdvisor';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';
import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
var imageAnimationDuration = 0.7;
var delayFactor = 500;
var renderImage = function renderImage(_ref, key) {
  var image = _ref.image,
    alt = _ref.alt,
    className = _ref.className,
    width = _ref.width,
    heigth = _ref.height,
    itemUrl = _ref.itemUrl,
    _ref$useEmptyPlacehol = _ref.useEmptyPlaceholder,
    useEmptyPlaceholder = _ref$useEmptyPlacehol === void 0 ? true : _ref$useEmptyPlacehol,
    analyticsClick = _ref.analyticsClick;
  if (!image) return null;
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), image])), width, heigth);
  return /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "poi__a",
    title: "poi link",
    "aria-label": "poi link",
    href: itemUrl,
    onClick: function onClick() {
      if (analyticsClick) analyticsClick();
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    key: key,
    useEmptyPlaceholder: useEmptyPlaceholder,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: className,
    src: imgSrc,
    alt: alt
  })));
};
export var POIBlock = function POIBlock(_ref2) {
  var item = _ref2.item,
    curatorsCopy = _ref2.curatorsCopy,
    callback = _ref2.callback,
    analytics = _ref2.analytics,
    _ref2$index = _ref2.index,
    index = _ref2$index === void 0 ? 0 : _ref2$index,
    hostLink = _ref2.hostLink,
    dictionary = _ref2.dictionary;
  var curators = get(item, 'curators.curators');
  var tripAdvRatingImage = get(item, 'tripadvisorImage');
  var tripAdvScore = get(item, 'tripadvisorscore');
  var mainTripadvisorReviews = get(item, 'tripadvisorReviews');
  var mainTripadvisorPrice = get(item, 'tripadvisorPrice');
  var bannerClickAnalytics = analytics.bannerClickAnalytics,
    titleClickAnalytics = analytics.titleClickAnalytics,
    addToFavAnalytics = analytics.addToFavAnalytics,
    smallBannerClickAnalytics = analytics.smallBannerClickAnalytics,
    params = analytics.params;
  return /*#__PURE__*/React.createElement("div", {
    className: "poi__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poi__image-wrap"
  }, item && renderImage({
    image: item.image,
    className: 'poi__image',
    alt: item.title,
    height: 243,
    width: 340,
    itemUrl: getListingItemURL(hostLink, item.urlSlug, item.url),
    analyticsClick: function analyticsClick() {
      return tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), item.englishTitle);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "poi__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: imageAnimationDuration * 1000 + delayFactor * index - 600
  }, /*#__PURE__*/React.createElement(CuratorPicks, {
    curators: curators,
    copy: curatorsCopy,
    analytics: {
      smallBannerClickAnalytics: smallBannerClickAnalytics,
      params: params,
      name: item.englishTitle
    }
  }), item && item.category && /*#__PURE__*/React.createElement("div", {
    className: "poi__text-sight"
  }, item && item.category && item.category.join(', ')), item && item.url && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "poi__item-title",
    href: item && getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), item.englishTitle);
    }
  }, item && item.title), /*#__PURE__*/React.createElement("p", {
    className: "body-small poi__text"
  }, item && item.introText), /*#__PURE__*/React.createElement(TripAdvisor, {
    imageRatingSRC: tripAdvRatingImage,
    score: tripAdvScore,
    alt: "Tripadvisor",
    tripadvisorReviews: mainTripadvisorReviews,
    tripadvisorPrice: mainTripadvisorPrice,
    reviewCaption: dictionary
  })), /*#__PURE__*/React.createElement(FavouriteBtn, {
    callback: callback,
    itemId: item && item.objectID,
    checkFavouriteButton: item && item.objectID,
    classes: 'poi_fav-btn',
    analyticsClick: function analyticsClick(e) {
      return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(e, ": ").concat(item.englishTitle));
    }
  })));
};
var POIs = function POIs(_ref3) {
  var fields = _ref3.fields,
    params = _ref3.params,
    route = _ref3.route,
    rendering = _ref3.rendering,
    uid = _ref3.uid;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    relatedItems = _useState2[0],
    setItem = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    mainItem = _useState4[0],
    setMainItem = _useState4[1];
  var moveToFirstButton = useRef(null);
  var contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  var datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  var moduleDictionary = get(fields, 'data.moduleDictionary');
  var defaultTitle = getDictionaryItem(moduleDictionary, 'PoisTitle');
  var isInteractive = get(fields, 'data.datasource.interactive.jss.value');
  var tabClickAnalytics = get(fields, 'data.tabClickAnalytics');
  //Context Sitecore
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var contextTags = getTags(get(fields, 'data.contextItem.tags'));
  var locationTag = get(fields, 'data.datasource.locationTag.items') || [];
  var theme = get(sitecoreContext, 'themesOfPage');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isVdsite = _useState6[0],
    setIsVdsite = _useState6[1];
  var renderingId = uid || get(rendering, 'uid') || 'pois-rendering-id';
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var currentPageID = get(route, 'itemId', '').split('-').join('');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var styleThemeHexColor = BackgroundColorHex ? {
    "--m34-pois-background-color": BackgroundColorHex,
    "--m34-pois-background-active-color": ActiveColorHex,
    "--m34-pois-color": ColorHex
  } : {
    "--m34-pois-background-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m34-pois-background-active-color": primaryActivePageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m34-pois-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var showFeatured = get(fields, 'data.datasource.showFeatured.jss.value');
  var searchCount = showFeatured ? Number(get(params, 'SearchCount')) + 1 : Number(get(params, 'SearchCount'));
  var useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  var considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  var listingPageLink = useCustomListingPage ? get(fields, 'data.datasource.listingPageLink.jss.url') : get(fields, 'data.overviewButton.link.jss.value.href');
  var overviewButton = get(fields, 'data.overviewButton.title.jss');
  var overviewLink = get(fields, 'data.overviewButton.link.jss.value.href');
  var contextItemId = get(fields, 'data.contextItem.id');
  var curtorListingPage = '';
  if (contextItemId) {
    curtorListingPage = "?curators.curators.Id=".concat(contextItemId);
  }
  var title = get(fields, 'data.datasource.title.jss') || {
    value: defaultTitle
  };
  var map = dictionaryValues.reduce(function (aggregator, currentValue) {
    return aggregator.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var _fields$data = fields.data,
    bannerClickAnalytics = _fields$data.bannerClickAnalytics,
    titleClickAnalytics = _fields$data.titleClickAnalytics,
    navBubblesAnalytics = _fields$data.navBubblesAnalytics,
    prevNextNavAnalytics = _fields$data.prevNextNavAnalytics,
    addToFavAnalytics = _fields$data.addToFavAnalytics,
    readMoreAnalytics = _fields$data.readMoreAnalytics,
    mobileSlidesAnalytics = _fields$data.mobileSlidesAnalytics,
    smallBannerClickAnalytics = _fields$data.smallBannerClickAnalytics;
  var allText = map.get('All') || '';
  var tagsValues = get(fields, 'data.datasource.tags.values') || [];
  if (tagsValues.length === 0) {
    tagsValues = get(fields, 'data.contextItem.tags.values');
  }
  var tags = tagsValues ? tagsValues.map(function (tag) {
    return {
      value: get(tag, 'title.jss.value'),
      name: tag.name,
      id: tag.id
    };
  }) : [];
  if (tags.length > 0) tags.unshift({
    value: allText,
    name: allText,
    id: "".concat(renderingId, "-all-values-id")
  });
  var curators = get(mainItem, 'curators.curators');
  var mainTripAdvisorRating = get(mainItem, 'tripadvisorImage');
  var mainTripAdvisorScore = get(mainItem, 'tripadvisorScore');
  var mainTripadvisorReviews = get(mainItem, 'tripadvisorReviews');
  var mainTripadvisorPrice = get(mainItem, 'tripadvisorPrice');
  var locationTagArray = locationTag.map(function (item) {
    var tag = get(item, 'name.jss.value');
    return "location:".concat(tag);
  });
  var _useState7 = useState("tags:All"),
    _useState8 = _slicedToArray(_useState7, 2),
    tagState = _useState8[0],
    setTagState = _useState8[1];
  var _useInView = useInView({
      threshold: 1,
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  var indexName = get(params, 'SearchIndex');
  var showCarouselOnMobile = get(fields, 'data.datasource.showCarouselOnMobile.jss.value');
  var isFeaturedItem = get(mainItem, 'featured');
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    seeMoreURLTags = _useState10[0],
    setSeeMoreURLTags = _useState10[1];
  var isPersonalised = get(sitecoreContext, 'isPersonalised');
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    validateItems = _useState12[0],
    setValidateItems = _useState12[1];
  var tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  var isTagsRuleUsed = isTagsRule(tagsRule);
  var tagsList = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : considerPageLevelTags ? [].concat(_toConsumableArray(contextItemTags), _toConsumableArray(datasourceTags)) : _toConsumableArray(datasourceTags);
  var intents = get(fields, 'data.datasource.intents');
  var intentsLength = get(intents, 'targetItems.length');
  var contextItem = get(fields, 'data.contextItem');

  // Resolve used conditions based on what is selected with the integrated query
  var conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  var allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(function (condition) {
    var handler = condition.handler,
      mappings = condition.mappings;
    var conditionValues = handler.getValues({
      mappings: mappings,
      sitecoreContext: sitecoreContext
    });
    if (conditionValues) {
      allValues.push.apply(allValues, _toConsumableArray(conditionValues));
    }
  });
  var _usePersonalizedList = usePersonalizedList({
      rendering: contextItem,
      route: route,
      list: relatedItems,
      conditions: [algoliaScoredCondition(allValues)]
    }),
    personalizedList = _usePersonalizedList.personalizedList,
    refreshTracking = _usePersonalizedList.refreshTracking;
  useEffect(function () {
    setValidateItems(isPersonalised && intentsLength ? personalizedList : relatedItems);
  }, [relatedItems, personalizedList]);
  useEffect(function () {
    if (inView) {
      setSeeMoreURLTags(generatrURLFromTags(tagsList));
      if (isPersonalised && intentsLength) {
        if (locationTagArray.length === 0) {
          _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var tags, hits, featuredItemList;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  tags = isTagsRuleUsed ? formatTagsRuleToFilters(tagsRule) : considerPageLevelTags ? [].concat(_toConsumableArray(contextTags), _toConsumableArray(itemTags)) : itemTags;
                  _context.next = 3;
                  return loadCategoryAlgoliaResults(allValues || [], 'type:POI', searchCount, tags, [contextItemId ? "curators.curators.Id:".concat(contextItemId) : ''], currentPageID ? "NOT objectID:".concat(currentPageID) : '', indexName);
                case 3:
                  hits = _context.sent;
                  // setResults(hits);
                  if (showFeatured) {
                    featuredItemList = hits ? getFeaturedItemAndList(hits) : {};
                    setItem(featuredItemList.list);
                    setMainItem(featuredItemList.featured || {});
                  } else {
                    setItem(hits);
                  }
                  refreshTracking();
                case 6:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        } else {
          _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            var hits, featuredItemList;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return loadCategoryAlgoliaResults(allValues || [], 'type:POI', searchCount, _toConsumableArray(locationTagArray), [], currentPageID ? "NOT objectID:".concat(currentPageID) : '', indexName);
                case 2:
                  hits = _context2.sent;
                  // setResults(hits);
                  featuredItemList = hits ? getFeaturedItemAndList(hits) : {};
                  setItem(featuredItemList.list);
                  setMainItem(featuredItemList.featured || {});
                  refreshTracking();
                case 7:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))();
        }
      } else {
        var _tags = tagState === 'tags:All' ? considerPageLevelTags ? [].concat(_toConsumableArray(contextTags), _toConsumableArray(itemTags)) : itemTags : [tagState];
        var facetFilters = [['type:POI'], _toConsumableArray(locationTagArray), [contextItemId ? "curators.curators.Id:".concat(contextItemId) : '']];
        var tagsFromRules = tagState === 'tags:All' ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [].concat(facetFilters, [tagState]);
        var itemFilter = {
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? tagsFromRules : [].concat(facetFilters, [_tags]),
          filters: currentPageID ? "NOT objectID:".concat(currentPageID) : ''
        };
        var results = [];
        getListing(indexName, itemFilter).then(function (hits) {
          if (showFeatured) {
            var featuredItemList = hits.hits ? getFeaturedItemAndList(hits.hits) : {};
            setItem(featuredItemList.list);
            results = _toConsumableArray(featuredItemList.list);
            setMainItem(featuredItemList.featured || {});
          } else {
            setItem(hits.hits);
            results = _toConsumableArray(hits.hits);
          }
          if (hits && hits.hits.length !== searchCount) {
            getListing(indexName, {
              hitsPerPage: searchCount - hits.hits.length,
              facetFilters: showFeatured ? [['type:POI'], ['featured: true']] : [['type:POI']]
            }).then(function (extraPOIs) {
              var finalResults = [].concat(_toConsumableArray(results), _toConsumableArray(extraPOIs.hits));
              var featuredItemList = finalResults ? getFeaturedItemAndList(finalResults) : {};
              setItem(featuredItemList.list);
              setMainItem(featuredItemList.featured || {});
            });
          }
        });
      }
    }
  }, [tagState, currentPageID, inView, isPersonalised]);
  var renderCarouselItems = function renderCarouselItems(tileItems, hostLink) {
    if (!tileItems || tileItems.length === 0) {
      return [];
    }
    var itemsToMap = !isFeaturedItem ? isInteractive ? searchCount : searchCount - 1 : searchCount;
    return tileItems.slice(0, itemsToMap).map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "poi__animate-item",
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 2,
        key: "tile-item-".concat(index)
      }, /*#__PURE__*/React.createElement(POIBlock, {
        item: item,
        curatorsCopy: map.get('CuratorsPick'),
        key: index,
        hostLink: hostLink,
        dictionary: getDictionaryItem(moduleDictionary, 'reviews'),
        analytics: {
          bannerClickAnalytics: bannerClickAnalytics,
          titleClickAnalytics: titleClickAnalytics,
          navBubblesAnalytics: navBubblesAnalytics,
          prevNextNavAnalytics: prevNextNavAnalytics,
          addToFavAnalytics: addToFavAnalytics,
          readMoreAnalytics: readMoreAnalytics,
          mobileSlidesAnalytics: mobileSlidesAnalytics,
          params: params
        }
      }));
    });
  };
  var renderTags = function renderTags(poiFormId) {
    if (!tags) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return tags.map(function (tag, index) {
      var facetType = 'tags:';
      var currentTag = tag;
      if (index === 0) {
        currentTag.value = 'All';
      }
      var animationFactor = 0.2;
      var uniqueId = "poi-".concat(tag.id);
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        key: uniqueId,
        duration: 1 + animationFactor * index
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi-checkbox__item",
        onClick: function onClick() {
          handleTagClick(currentTag, facetType);
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: uniqueId,
        value: index === 0 ? 'tags:All' : facetType + tag.value,
        name: poiFormId,
        tabIndex: 0,
        checked: facetType + tag.value === tagState,
        onChange: function onChange() {
          return setTagState(facetType + currentTag.value);
        }
      }), /*#__PURE__*/React.createElement("label", {
        className: "body-small poi-checkbox__label",
        htmlFor: uniqueId
      }, /*#__PURE__*/React.createElement("span", {
        className: "poi-checkbox__label-text"
      }, tag.value === 'All' ? allText : tag.value))));
    });
  };
  var handleTagClick = function handleTagClick(value, facetType) {
    if (tagState !== facetType + value.value) {
      // if tag is changed
      if (moveToFirstButton.current) {
        moveToFirstButton.current.click();
      }
    }
    tealiumClickFunc(tealiumMergeClickData(tabClickAnalytics, params), "".concat(value.name));
  };
  var renderFeaturedItem = function renderFeaturedItem() {
    if (isInteractive) return null;
    if (showFeatured && mainItem.url && mainItem.urlSlug) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx('poi__featured-block', 'poi__featured-block--highlighted', 'theme-contrast', {
          'brand-bd': theme
        })
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "poi__featured__bg-animate",
        animateIn: "animate__slideInRight",
        animateOnce: true,
        duration: 1,
        offset: 150
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__featured__bg-color"
      })), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xl-11"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__title-block"
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "h2",
        className: "poi__title",
        field: title
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "poi__item poi__featured-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-md-5 col-lg-5 col-xl-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__featured-image-wrap"
      }, mainItem && renderImage({
        image: mainItem.image,
        width: 700,
        height: 428,
        className: 'poi__featured-image',
        itemUrl: getListingItemURL(overviewLink + curtorListingPage, mainItem.urlSlug, mainItem.url),
        alt: mainItem.title,
        analyticsClick: function analyticsClick() {
          return tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), mainItem.englishTitle);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-md-7 col-lg-7 col-xl-3 poi__featured-info-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__info"
      }, /*#__PURE__*/React.createElement(FavouriteBtn, {
        itemId: mainItem && mainItem.objectID,
        classes: 'poi_fav-btn',
        analyticsClick: function analyticsClick(e) {
          return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(e, ": ").concat(mainItem.englishTitle));
        }
      }), /*#__PURE__*/React.createElement(CuratorPicks, {
        curators: curators,
        copy: map.get('CuratorsPick') || '',
        analytics: {
          smallBannerClickAnalytics: smallBannerClickAnalytics,
          params: params,
          name: mainItem.englishTitle
        }
      }), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__text-sight"
      }, /*#__PURE__*/React.createElement("span", null, mainItem && mainItem.category && mainItem.category.join(', ')))), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.05
      }, /*#__PURE__*/React.createElement(RouterLink, {
        openInSameTab: true,
        className: "poi__item-title",
        href: mainItem && mainItem.url,
        onClick: function onClick() {
          return tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), mainItem.englishTitle);
        }
      }, /*#__PURE__*/React.createElement("span", null, mainItem && mainItem.title))), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.1
      }, /*#__PURE__*/React.createElement("p", {
        className: "body-small poi__text"
      }, mainItem && mainItem.introText)), /*#__PURE__*/React.createElement("div", {
        className: "poi__push-bottom"
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.15
      }, /*#__PURE__*/React.createElement(TripAdvisor, {
        imageRatingSRC: mainTripAdvisorRating,
        score: mainTripAdvisorScore,
        alt: "Tripadvisor",
        tripadvisorReviews: mainTripadvisorReviews,
        tripadvisorPrice: mainTripadvisorPrice,
        reviewCaption: getDictionaryItem(moduleDictionary, 'reviews')
      }))))))));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xl-11"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__title-block"
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "h3",
        className: "poi__title poi__title--no-featured",
        field: title
      })))));
    }
  };
  var renderCarouselFilteredItem = function renderCarouselFilteredItem(isInteractive, hostLink) {
    var items = isPersonalised && intentsLength ? personalizedList : relatedItems;
    if (items && items.length > 0) {
      return /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref6) {
        var renderCarousel = _ref6.renderCarousel,
          renderPreviousButton = _ref6.renderPreviousButton,
          renderNextButton = _ref6.renderNextButton,
          renderDots = _ref6.renderDots,
          state = _ref6.state,
          moveToSlide = _ref6.moveToSlide;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-xl-9 offset-xl-1"
        }, /*#__PURE__*/React.createElement("div", {
          className: "row poi__items-row ".concat(rtl && get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'item-rtl-carousal-fix' : '')
        }, renderCarousel(renderCarouselItems(items, hostLink), {
          responsive: {
            desktop: {
              breakpoint: {
                max: 10000,
                min: 768
              },
              items: 3
            },
            tablet: {
              breakpoint: {
                max: 767,
                min: 480
              },
              items: 2
            },
            mobile: {
              breakpoint: {
                max: 479,
                min: 310
              },
              items: 1
            }
          },
          itemClass: 'poi__item-col poi__item-col-wm'
        }, function () {
          return tealiumClickFunc(tealiumMergeClickData(mobileSlidesAnalytics, params));
        }))), /*#__PURE__*/React.createElement("div", {
          className: "poi-pagination__btn btn-group--left ".concat(rtl ? 'btn-group-rtl' : '')
        }, renderPreviousButton(function () {
          return tealiumClickFunc(tealiumMergeClickData(prevNextNavAnalytics, params));
        })), ' ', /*#__PURE__*/React.createElement("div", {
          className: "poi-pagination__btn btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
        }, renderNextButton(function () {
          return tealiumClickFunc(tealiumMergeClickData(prevNextNavAnalytics, params));
        })), /*#__PURE__*/React.createElement("div", {
          className: "poi-pagination__dots"
        }, renderDots(function () {
          return tealiumClickFunc(tealiumMergeClickData(navBubblesAnalytics, params));
        })), /*#__PURE__*/React.createElement("button", {
          onClick: function onClick() {
            moveToSlide(0);
          },
          ref: moveToFirstButton,
          className: "d-none"
        }, "move to slide 0"));
      });
    } else {
      if (isInteractive) {
        return /*#__PURE__*/React.createElement("div", {
          className: "message-no-item rs_skip"
        }, /*#__PURE__*/React.createElement("span", null, map.get('ItemsNotFound')));
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  var renderTileItems = function renderTileItems() {
    var poiFormId = "poi-checkbox-".concat(renderingId);
    return /*#__PURE__*/React.createElement(React.Fragment, null, isInteractive && /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-11 offset-xl-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "poi__title-block"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "poi__title poi__interactive-title",
      field: title
    }))), /*#__PURE__*/React.createElement("div", {
      className: "row poi__filters-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "poi-checkbox poi-checkbox--mob-scroll  ".concat(theme ? 'brand-checkbox' : '')
    }, /*#__PURE__*/React.createElement("form", {
      id: poiFormId
    }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
      hidden: true
    }, defaultTitle), renderTags(poiFormId))))))), /*#__PURE__*/React.createElement("div", {
      className: ['row poi__items-margin', 'poi__items-stack', 'full-width', validateItems && validateItems.length > 3 ? 'poi__items-carousel' : ''].join(' ')
    }, renderCarouselFilteredItem(isInteractive, overviewLink + curtorListingPage), /*#__PURE__*/React.createElement("div", {
      className: "poi-stacked-mobile"
    }, !showCarouselOnMobile && validateItems && validateItems.slice(0, isFeaturedItem ? searchCount : searchCount - 1).map(function (item, index) {
      return /*#__PURE__*/React.createElement(POIBlock, {
        item: item && item.item ? item.item : item,
        curatorsCopy: map.get('CuratorsPick'),
        key: index,
        hostLink: overviewLink + curtorListingPage,
        analytics: {
          bannerClickAnalytics: bannerClickAnalytics,
          titleClickAnalytics: titleClickAnalytics,
          navBubblesAnalytics: navBubblesAnalytics,
          prevNextNavAnalytics: prevNextNavAnalytics,
          addToFavAnalytics: addToFavAnalytics,
          readMoreAnalytics: readMoreAnalytics,
          mobileSlidesAnalytics: mobileSlidesAnalytics,
          params: params
        },
        dictionary: getDictionaryItem(moduleDictionary, 'reviews')
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "row col-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-xl-11"
    }, overviewButton && /*#__PURE__*/React.createElement("div", {
      className: "poi__more-bar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-none d-md-block"
    }, overviewLink && /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1.5
    }, /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      className: "btn btn-link",
      href: listingPageLink + curtorListingPage + seeMoreURLTags,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(readMoreAnalytics, params));
      },
      ariaLabel: "".concat(title.value, " | ").concat(overviewButton.value)
    }, /*#__PURE__*/React.createElement(Text, {
      field: overviewButton,
      className: "btn-link__text",
      tag: "span"
    }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "btn-link__icon btn-link-icon"
    }) : /*#__PURE__*/React.createElement(ChevronRight, {
      className: "btn-link__icon btn-link-icon"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "d-md-none rs_skip"
    }, overviewLink && /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1.5
    }, /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      href: listingPageLink + curtorListingPage + seeMoreURLTags,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), getLastPartInURL(overviewLink));
      },
      ariaLabel: "".concat(title.value, " | ").concat(overviewButton.value)
    }, /*#__PURE__*/React.createElement(Text, {
      className: "btn btn-primary",
      tag: "span",
      field: overviewButton
    })))))))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: styleThemeHexColor,
    className: "".concat(showCarouselOnMobile ? 'show-carousel-mobile' : 'hide-carousel-mobile')
  }, renderFeaturedItem(), renderTileItems()));
};
var StyledWrapper = function StyledWrapper(_ref7) {
  var children = _ref7.children,
    rtl = _ref7.rtl,
    anchorUrlParameter = _ref7.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(poiStyle, " ").concat(rtl ? rtlStyles : ltrStyles, "  ").concat(ColorsLogic)
  }, children);
};
var ColorsLogic = "c1vy3kw9";
var poiStyle = "phis2rz";
var ltrStyles = "l1k8w2a6";
var rtlStyles = "rv2wvvo";
export default POIs;